/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast.
* Uncomment the custom.js script import line in layout/theme.liquid to use it.
*/

(function() {
  // All custom scripts below run once the DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {

    /* ----------------------------------------------------------------
      REMOVE SKU LABEL
    ---------------------------------------------------------------- */
    const skuElement = document.querySelector('.product__sku');
    if (skuElement) {
      skuElement.textContent = skuElement.textContent.replace('SKU: ', '');
    }

    /* ----------------------------------------------------------------
      CHANGE HEADER COLOUR ON SAFARI
    ---------------------------------------------------------------- */
    let themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (!themeColorMeta) {
      themeColorMeta = document.createElement('meta');
      themeColorMeta.setAttribute('name', 'theme-color');
      document.head.appendChild(themeColorMeta);
    }
    themeColorMeta.setAttribute('content', '#ffffff'); // Change to preferred color

   
/* ----------------------------------------------------------------
      SOLD OUT BADGE PLACEMENT - INFO ONLY
    ---------------------------------------------------------------- */

// script insert starting at line 770 and ending at line 800 in file snippets/product-grid-item.liquid

/* ----------------------------------------------------------------
      HIDE DESCRIPTION TAB CONTENT UNTIL CLICKED - IONFO ONLY
    ---------------------------------------------------------------- */


// 'current' class removed from lines 29 & 35 in file snippets/product-tabs.liquid


    /* ----------------------------------------------------------------
      HIDE COMPLIMENTARY PRODUCTS IF EMPTY
    ---------------------------------------------------------------- */
    const complementaryProductsSection = document.querySelector('.product__complementary');
    const complementaryProducts = document.querySelector('complementary-products'); // adjust if class or ID

    if (complementaryProductsSection && complementaryProducts) {
      const observer = new MutationObserver(function() {
        const productElements = complementaryProducts.querySelectorAll('.product-upsell');
        if (productElements.length === 0) {
          complementaryProductsSection.style.display = 'none';
        } else {
          observer.disconnect();
        }
      });
      observer.observe(complementaryProducts, { childList: true, subtree: true });
    }

    /* ----------------------------------------------------------------
      INSERT SHIPPING ACCORDION INTO PRODUCT TAB
    ---------------------------------------------------------------- */
    const accordionHTML = `
      <div id="shopify-section-template--17893582078106__section_accordion_group_RHMjij" class="shopify-section">
        <style>
          #AccordionGroup--template--17893582078106__section_accordion_group_RHMjij {
            --PT: 50px; --PB: 50px; --accordion-columns: 1;
          }
        </style>
        <div id="AccordionGroup--template--17893582078106__section_accordion_group_RHMjij" class="accordion-group section-padding color-scheme-1">
          <div class="faq wrapper--narrow" data-section-id="template--17893582078106__section_accordion_group_RHMjij" data-section-type="faq">
            <collapsible-elements single="true">
              <div class="accordion-group__items">
                <details class="accordion aos-animate" data-aos="hero" data-aos-order="1">
                  <summary class="accordion__title font-heading heading-small">Australia
                    <svg aria-hidden="true" class="icon icon-plus" viewBox="0 0 24 24"><path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    <svg aria-hidden="true" class="icon icon-minus" viewBox="0 0 24 24"><path d="M6 12h12" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </summary>
                  <div class="accordion__body rte">
                    <div class="accordion__content">
                      <p>Orders over $250<br>Complimentary Shipping</p>
                      <p>Orders under $250<br>Shipping calculated at Checkout</p>
                      <p><a href="https://aleks-studio.myshopify.com/pages/customercare">More information</a></p>
                    </div>
                  </div>
                </details>
                <details class="accordion aos-animate" data-aos="hero" data-aos-order="2">
                  <summary class="accordion__title font-heading heading-small">USA
                    <svg aria-hidden="true" class="icon icon-plus" viewBox="0 0 24 24"><path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    <svg aria-hidden="true" class="icon icon-minus" viewBox="0 0 24 24"><path d="M6 12h12" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </summary>
                  <div class="accordion__body rte">
                    <div class="accordion__content">
                      <p>Orders over $250 USD<br>Complimentary Shipping</p>
                      <p>Orders under $250 USD<br>Shipping calculated at Checkout</p>
                      <p><a href="https://aleks-studio.myshopify.com/pages/customercare">More information</a></p>
                    </div>
                  </div>
                </details>
                <details class="accordion aos-animate" data-aos="hero" data-aos-order="3">
                  <summary class="accordion__title font-heading heading-small">International
                    <svg aria-hidden="true" class="icon icon-plus" viewBox="0 0 24 24"><path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    <svg aria-hidden="true" class="icon icon-minus" viewBox="0 0 24 24"><path d="M6 12h12" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </summary>
                  <div class="accordion__body rte">
                    <div class="accordion__content">
                      <p>Shipping calculated at Checkout</p>
                      <p><a href="https://aleks-studio.myshopify.com/pages/customercare">More information</a></p>
                    </div>
                  </div>
                </details>
              </div>
            </collapsible-elements>
          </div>
        </div>
      </div>`;

    const shippingTab = document.querySelector('.tab-content-1.rte');
    if (shippingTab) {
      shippingTab.innerHTML = accordionHTML;
    }

    /* ----------------------------------------------------------------
      FIRST VARIANT / FIND IN STORE / BIS CONFLICT HANDLER
    ---------------------------------------------------------------- */
    const productSubmit = document.querySelector('.product__submit');
    const findInStore = document.querySelector('.product__store-availability-container');
    const atcButton = document.querySelector('[data-add-to-cart]');
    const bisButton = document.querySelector('.klaviyo-bis-trigger');

    // Select first variant and trigger variant change
    function selectFirstVariant() {
      const selectors = document.querySelectorAll('[data-single-option-selector]');
      selectors.forEach(selector => {
        const firstRadio = selector.closest('fieldset')?.querySelector('input[type="radio"]');
        if (firstRadio && !firstRadio.checked) {
          firstRadio.checked = true;
          firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      const fallbackSelect = document.querySelector('form[action^="/cart"] select[name="id"]');
      let selectedId = fallbackSelect?.value;

      if (!selectedId && window.product?.variants?.length) {
        selectedId = window.product.variants[0].id;
      }

      const selectedVariant = window?.product?.variants?.find(v => v.id == selectedId);
      if (selectedVariant) {
        document.dispatchEvent(new CustomEvent('theme:variant:change', {
          detail: { variant: selectedVariant }
        }));
      }
    }

    // Check if selected variant is out of stock
    function isSelectedVariantOutOfStock() {
      const fallbackSelect = document.querySelector('form[action^="/cart"] select[name="id"]');
      const selectedId = fallbackSelect?.value;
      const selectedVariant = window?.product?.variants?.find(v => v.id == selectedId);
      return selectedVariant ? !selectedVariant.available : false;
    }

    // Toggle Find in Store visibility
    function toggleFindInStore() {
      if (findInStore && atcButton) {
        if (atcButton.disabled || isSelectedVariantOutOfStock()) {
          findInStore.style.display = 'none';
        } else {
          findInStore.style.display = '';
        }
      }
    }

    // Hide Add to Cart if BIS (Back in Stock) is visible
    function toggleAddToCartIfBIS() {
      const isBISVisible = bisButton && bisButton.offsetParent !== null;
      if (productSubmit) {
        productSubmit.style.display = isBISVisible ? 'none' : '';
      }
    }

    // Poll for BIS visibility
    function pollForBIS(attemptsLeft = 20) {
      toggleAddToCartIfBIS();
      if (attemptsLeft <= 0) return;
      if (!bisButton || bisButton.offsetParent === null) {
        setTimeout(() => pollForBIS(attemptsLeft - 1), 100);
      }
    }

    // Combined checks
    function runAllChecks() {
      toggleFindInStore();
      toggleAddToCartIfBIS();
    }

    // Delay to ensure DOM mounts
    setTimeout(() => {
      selectFirstVariant();
      runAllChecks();
      pollForBIS();
    }, 100);

    // Re-check when variant changes
    document.querySelectorAll('[data-single-option-selector]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const fallbackSelect = document.querySelector('form[action^="/cart"] select[name="id"]');
        const selectedId = fallbackSelect?.value;
        const selectedVariant = window?.product?.variants?.find(v => v.id == selectedId);

        if (selectedVariant) {
          document.dispatchEvent(new CustomEvent('theme:variant:change', {
            detail: { variant: selectedVariant }
          }));
        }

        runAllChecks();
        pollForBIS();
      });
    });

    // Re-run if BIS injected late
    const observer = new MutationObserver(runAllChecks);
    observer.observe(document.body, { childList: true, subtree: true });

  }); // end DOMContentLoaded
})(); // end IIFE